export default __webpack_public_path__ + "static/media/cta-packs.8c3a6ac5.jpg";